import React from 'react';
import styles from './RadioButtonGroup.module.scss';
import classNames from 'classnames/bind';
import {InputGuide, LabelText} from '../../atoms';

const cx = classNames.bind(styles);

const RadioButtonGroup = ({labelText, inputGuideText, defaultHideGuide, isError, className, children}) => {
  return (
    <div className={`${cx('RadioButtonGroup')} ${className}`}>
      <LabelText className={cx('RadioButtonGroup__label')} text={labelText} />
      {children}
      <InputGuide text={inputGuideText} isError={isError} defaultHide={defaultHideGuide} />
    </div>
  );
};

export default RadioButtonGroup;